import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import "../WidgetDialog.scss";
import usePermissions from "hooks/usePermissions";
import WidgetType from "./WidgetType";
import widgetTypeConstants from "./widgetTypeConstants";

/**
 * This component renders the widget types that can be added to the dashboard.
 */
const WidgetTypes = function ({ handleWidgetTypeClick, dashboardWidgets }) {
  const intl = useIntl();
  const { permissions } = usePermissions();
  const userType = JSON.parse(permissions).user_type;
  return (
    <div className="grid">
      {widgetTypeConstants(intl, userType).map((widget) => (
        <WidgetType
          key={widget.type}
          widget={widget}
          handleWidgetTypeClick={handleWidgetTypeClick}
          dashboardWidgets={dashboardWidgets}
        />
      ))}
    </div>
  );
};

WidgetTypes.propTypes = {
  handleWidgetTypeClick: PropTypes.func.isRequired,
  dashboardWidgets: PropTypes.instanceOf(Array),
};

WidgetTypes.defaultProps = {
  dashboardWidgets: [],
};

export default WidgetTypes;
